import { type JSX } from 'react';
import { enableNewReviewSaveModal } from '@gonfalon/dogfood-flags/dogfood-flags';
import { Details } from '@gonfalon/ui/details';
import { clsx } from 'clsx';

import styles from './styles.module.css';

export type CollapsibleInstructionListItemProps = {
  initialOpen: boolean;
  categoryHeader: string;
  categoryInsElems: JSX.Element[];
  hideCategoryHeaders?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export function CollapsibleInstructionListItem({
  categoryHeader,
  initialOpen,
  categoryInsElems,
  hideCategoryHeaders,
  open,
  onOpenChange,
}: CollapsibleInstructionListItemProps) {
  const newReviewSaveModalEnabled = enableNewReviewSaveModal();
  return (
    <li
      className={clsx({
        [styles.collapsibleInstructionListItemCategory]: !newReviewSaveModalEnabled,
        [styles.collapsibleInstructionListItemCompact]: newReviewSaveModalEnabled,
      })}
    >
      {hideCategoryHeaders ? (
        <ul>{categoryInsElems}</ul>
      ) : (
        <Details
          className={clsx({
            [styles.details]: enableNewReviewSaveModal(),
          })}
          prependCaret={enableNewReviewSaveModal()}
          initialOpen={initialOpen}
          open={open}
          summary={categoryHeader}
          onOpenChange={onOpenChange}
        >
          <ul>{categoryInsElems}</ul>
        </Details>
      )}
    </li>
  );
}
